import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent } from 'lib-trend-core';
interface AgentCard {
  key: string;
  title: string;
  subtitle: string;
  description?: string;
  route: string[];
  icon: string;
  visible: () => boolean;
}

@Component({
    selector: 'app-agents',
    templateUrl: './agents.component.html',
    styleUrls: ['./agents.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgentsComponent extends AbstractComponent {

  public cards: AgentCard[] = [
    {
      key: 'openai',
      title: 'OpenAI',
      subtitle: this.t('agents.home.openaiSubtitle'),
      description: this.t('agents.home.openaiDescription'),
      route: ['/agents/openai'],
      icon: 'mdi mdi-robot-outline',
      visible: () => this.isAdmin()
    },
    {
      key: 'trendgpt',
      title: 'TrendGPT',
      subtitle: this.t('agents.home.trendgptSubtitle'),
      description: this.t('agents.home.trendgptDescription'),
      route: ['trendgpt'],
      icon: 'mdi mdi-robot-outline',
      visible: () => this.isAdmin()
    }
  ];
}
